export const INVOICE_DUE_DATE_VALUES = {
  '15': 15,
  '30':30,
  '45':45,
  '60':60,
  '90':90,
};